import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div style={s.page}>
      <div style={s.card}>

        <div style={s.header}>
          <img src="/Ask Nitin Brand.png" alt="Ask Nitin" style={s.brandImg} />
          <div style={s.sub}>Personal Mentor for Law Students</div>
        </div>

        <p style={s.welcome}>Welcome Note</p>

        <p style={{ ...s.intro, fontFamily: "'Playfair Display', Georgia, serif", fontWeight: '700', color: 'var(--navy)', fontSize: '16px' }}>Dear Young Lawyers</p>

        <p style={s.intro}>Every student I have ever spoken to have the same problem, not a lack of ability, but a lack of someone who would speak to them honestly.</p>

        <p style={s.intro}>This platform is my attempt to be that person, at scale.</p>

        <p style={s.intro}>
          Ask Nitin is the digital home of my programme <em>Conversations with Nitin Potdar</em>. For years I have been meeting law students one on one, listening to their questions, their confusion and their anxieties, and trying to give them the honest, practical guidance that most law schools simply do not provide. I deeply value every one of those conversations. But I am physically unable to meet everyone personally. This is my answer to that.
        </p>

        <p style={s.intro}>You will find these tools here. Each one addresses a question I am asked constantly. And all my answers strictly based on my book <em>Companion Hand Book for Law Students - what they don't teach at the law schools in India</em> & <em>GPS Paradigm</em> and my several LinkedIn Posts and the Conversations that I had with Law Students.</p>

        <div style={s.toolList}>
          <Link to="/ask" style={s.toolLink}>
            <div style={s.toolItem}>
              <span style={s.toolDot} />
              <div>
                <strong>Ask Nitin</strong>
                <br/><span style={{ fontStyle: 'italic', color: 'var(--gold)' }}>"Every law student is desperate to speak to someone senior and get real answers. Here is yours."</span>
                <br/>Ask anything about your career - internships, choice of practice area, your first job or placement - and get straight, experience-backed guidance from someone who has truly been there.
              </div>
            </div>
          </Link>
          <Link to="/sprint" style={s.toolLink}>
            <div style={s.toolItem}>
              <span style={s.toolDot} />
              <div>
                <strong>Sprint</strong>
                <br/><span style={{ fontStyle: 'italic', color: 'var(--gold)' }}>"Mentorship is not advice. It is doing the work together."</span>
                <br/>A structured mentorship programme for 1st, 2nd and 3rd year law students. Complete two tasks, demonstrate your commitment, and earn a personal Zoom session with Nitin.
              </div>
            </div>
          </Link>
          <Link to="/assessment" style={s.toolLink}>
            <div style={s.toolItem}>
              <span style={s.toolDot} />
              <div>
                <strong>Find Your Practice Area</strong>
                <br/><span style={{ fontStyle: 'italic', color: 'var(--gold)' }}>"Most law students pick their practice area by accident. You do not have to."</span>
                <br/>A 20-question self-assessment that goes deeper than grades and internships, into your temperament and your genuine readiness. Discover where you truly belong before the profession decides for you.
              </div>
            </div>
          </Link>
          <Link to="/resume" style={s.toolLink}>
            <div style={s.toolItem}>
              <span style={s.toolDot} />
              <div>
                <strong>Resume Builder and Assessment</strong>
                <br/><span style={{ fontStyle: 'italic', color: 'var(--gold)' }}>"Your resume is not a document. It is your first conversation with a partner who has never met you."</span>
                <br/>Build it with the seriousness it deserves. Craft a professional legal resume shaped by Nitin's insider knowledge of what Indian law firms and in-house teams are genuinely looking for, and make that first conversation count.
              </div>
            </div>
          </Link>
          <Link to="/mock-interview" style={s.toolLink}>
            <div style={s.toolItem}>
              <span style={s.toolDot} />
              <div>
                <strong>Mock Interview with Nitin</strong>
                <br/><span style={{ fontStyle: 'italic', color: 'var(--gold)' }}>"An interview without preparation is not an interview. It is a missed opportunity."</span>
                <br/>A guided one-to-one conversation where you upload your CV, answer real interview questions, and receive a personal closing note from Nitin reflecting on who you are, what to work on, and where your strengths lie.
              </div>
            </div>
          </Link>
        </div>

        <p style={{ ...s.intro, fontStyle: 'italic' }}>Welcome. I am glad you are here.</p>

        <p style={s.signature}>– Nitin Potdar</p>

      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', background: 'var(--bg)',
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
    padding: '32px 16px 48px', boxSizing: 'border-box',
  },
  card: {
    background: '#fff', borderRadius: '20px',
    boxShadow: '0 4px 24px rgba(12,35,64,0.08)',
    width: '100%', maxWidth: '640px',
    padding: '32px 36px',
    display: 'flex', flexDirection: 'column', gap: '16px',
  },
  header: {
    display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '4px',
  },
  brandImg: { height: '44px', objectFit: 'contain', alignSelf: 'flex-start' },
  sub: { fontSize: '12px', color: 'var(--text-2)', fontWeight: '600', marginTop: '2px' },
  welcome: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: '22px', fontWeight: '700', color: 'var(--navy)', margin: 0,
  },
  intro: { fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.7', margin: 0 },
  toolLink: { textDecoration: 'none', color: 'inherit', display: 'block', borderRadius: '10px', transition: 'background 0.15s', padding: '2px' },
  toolList: { display: 'flex', flexDirection: 'column', gap: '12px', paddingLeft: '4px' },
  toolItem: {
    display: 'flex', gap: '10px', alignItems: 'flex-start',
    fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.65',
  },
  toolDot: {
    width: '7px', height: '7px', borderRadius: '50%',
    background: 'var(--gold)', flexShrink: 0, marginTop: '6px',
  },
  signature: {
    fontSize: '13px', fontWeight: '600', color: 'var(--text-3)',
    fontStyle: 'italic', marginTop: '4px',
  },
};
